export class CommunicationTemplate {
  Confidential: { Value: string } = null;
  AssignedTo: { Value: string } = null;
  Priority: { Value: string } = null;
  Status: { Value: string } = null;
}
